import { Box, Button, styled, Typography } from '@mui/material';

interface SubHeaderContainerProps {
  alignItems?: string;
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
}

export const SubHeaderContainer = styled(Box)<SubHeaderContainerProps>`
  padding: 16px 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: ${({ alignItems = 'center' }) => alignItems};
  ${({
    flexDirection,
  }: {
    flexDirection?: SubHeaderContainerProps['flexDirection'];
  }) => flexDirection && `flex-direction: ${flexDirection};`}
`;

export const StyledLabel = styled('label')<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 500,
    display: 'inline-block',
    marginBottom: '2px',
    userSelect: disabled ? 'none' : 'auto',
    cursor: disabled ? 'not-allowed' : 'pointer',
    textAlign: 'left',
    opacity: disabled ? 0.6 : 1,
    '&:focus, &:active': {
      userSelect: disabled ? 'none' : 'auto',
    },
  }),
);

export const StyledSortButton = styled(Button)`
  color: rgba(0, 0, 0, 0.6);
  font-size: 15px;
  font-weight: 500;
`;

export const StyledPageSizeButton = styled(Button)`
  color: rgba(0, 0, 0, 0.6);
  font-size: 15px;
  font-weight: 500;
`;

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop: any) => prop !== 'paddingTop',
})<{ paddingTop?: number }>(({ theme, paddingTop }) => ({
  color: theme.palette.text.secondary,
  paddingTop: paddingTop !== undefined ? theme.spacing(paddingTop) : undefined,
}));

export const HeaderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}));

export const TitleContainer = styled('div')({
  flex: 1,
});

export const ActionsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 24, // same as gap={3} since theme.spacing(3) = 24px
});
